import { render, staticRenderFns } from "./infor-card.vue?vue&type=template&id=d90a13b6&"
import script from "./infor-card.vue?vue&type=script&lang=js&"
export * from "./infor-card.vue?vue&type=script&lang=js&"
import style0 from "./infor-card.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "infor-card.vue"
export default component.exports